<template>
  <slot v-bind="{ granted: checkRbacPermissions(props.permissions) }" />
</template>

<script setup>
import { useAppAuthData } from '@/stores/app/authData';

/**
 * Renderless base component that resolves RBAC permissions and exposes a
 * `granted` boolean via the default slot prop. Use HideRbac or DisableRbac
 * for common UI patterns built on top of this primitive.
 */
defineOptions({ name: 'CheckRbac' });

const props = defineProps({
  permissions: {
    type: Array,
    default: () => [],
  },
});

const { checkRbacPermissions } = useAppAuthData();
</script>
